<template>
  <div class="app">
    <router-view></router-view>
    <TabBar v-if="loggedIn" />
  </div>
</template>

<script>
const TabBar = () => import('@/components/TabBar')

export default {
  name: 'App',

  components: { TabBar },

  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    }
  }
}
</script>
